import React, { useState, useEffect } from 'react';
import Opponents from '../components/bunteliga/Opponents';
import Games from '../components/bunteliga/Games';
import axios from 'axios';
import Score from '../components/bunteliga/Score';
import Tournament from '../components/turniere/Tournament';
import Freizeitkick from '../components/freizeitkick';
import Meetings from '../components/Meetings/Meetings';

function Events() {
    const [games, setGames] = useState([]);
    const [opponents, setOpponents] = useState([]);
    const [loading, setLoading] = useState(false);

    // Funktion zum Abrufen der Games-Daten
    const fetchGames = () => {
        setLoading(true);
        axios
            .get('api/Games')
            .then((response) => {
                setGames(response.data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    // Funktion zum Abrufen der Opponents-Daten
    const fetchOpponents = () => {
        setLoading(true);
        axios
            .get('api/Opponents')
            .then((response) => {
                setOpponents(response.data.data);
                setLoading(false);
            })
            .catch((error) => {
                console.log(error);
                setLoading(false);
            });
    };

    // useEffect für Initiales Laden der Daten
    useEffect(() => {
        fetchGames();
        fetchOpponents();
    }, []);

    return (
        <>
            <div className='container-fluid'>
                <p className="rakete-font headline fs-1 mt-3 my-2 mb-2 fw-semibold mt-3 text-center text-uppercase">Bunte Liga</p>
                <div className="row mt-3">
                    <div className='col-md-6'>
                        <Score games={games} />
                    </div>
                    <div className='col-md-6'>
                        <Games games={games} opponents={opponents} onGameChange={fetchGames} />
                        <Opponents opponents={opponents} onChange={fetchOpponents} />
                    </div>
                </div>
                <Tournament />
                <Freizeitkick/>
                <Meetings />

            </div>
        </>
    )
}

export default Events;
